@if (!hidden) {
  <div class="app-alert" [class.d-inline-flex]="inline" [class]="typeClass" [class.no-close-button]="!(dismiss.observers.length > 0)">
    <i class="im-icon im-icon-{{icon}} alert-icon"></i>
    <div class="alert-text">{{text}}</div>
    <div class="close-icon-wrap" (click)="dismiss.emit(); hidden = true;"><i class="im-icon im-icon-x-light close-icon"></i></div>
  </div>
}